import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import PanelHeader from "./panelHeader";


const SliderNumeric = ({ textLen, label, color, callback, reset, initialValue }) => {
    const [minMax, _] = useState(textLen);
    // Use initialValue if provided, otherwise use textLen
    const [values, setValues] = useState(initialValue || textLen);

    const onChange = (event) => {
        setValues(event.target.value);
    }
    const onChangeCommitted = (event) => {
        callback(values)
    }
    // reset slider when reset is changed on filterReset
    useEffect(() => {
        setValues(textLen)
    }, [reset])

    // Update values when initialValue changes
    useEffect(() => {
        if (initialValue) {
            setValues(initialValue);
        }
    }, [initialValue]);

    return <Box sx={{ 'width': '100%' }}>
        <Box sx={{ mt: 2, mb: 1 }}>
            <Slider
                value={values}
                size="small"
                valueLabelDisplay="on"
                marks={true}
                step={1}
                min={minMax[0]}
                max={minMax[1]}
                onChange={onChange}
                color={color}
                onChangeCommitted={onChangeCommitted}

            />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5 }}>
                <Typography variant="caption" sx={{ fontWeight: 'bold' }} color="text.primary">
                    {minMax[0]} s
                </Typography>
                <Typography variant="caption" sx={{ fontWeight: 'bold' }} color="text.primary">
                    {minMax[1]} s
                </Typography>

            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 0.5 }}>
                <Typography variant="caption" sx={{ mb: 1, display: 'block', fontWeight: 'bold' }}>
                    Seconds range: {values[0]} s to: {values[1]} s
                </Typography>
            </Box>
        </Box>
    </Box>
}

export default SliderNumeric
